import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import * as AOS from 'aos';
import Swiper from 'swiper'; // Import Swiper library if not already imported
import { Constants } from '../../common/constants';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-operation-maintanance',
  templateUrl: './operation-maintanance.component.html',
  styleUrls: ['./operation-maintanance.component.css']
})
export class OperationMaintananceComponent implements OnInit {
  isBrowser: boolean = false;

  @ViewChild('swiperContainer') swiperContainer!: ElementRef;
  constructor(private elementRef: ElementRef,private seoService:SeoService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
     private titleService: Title, @Inject(PLATFORM_ID) private platformId: any,

    private metaService: Meta) { this.isBrowser = isPlatformBrowser(this.platformId); }

  baseUrl = Constants.baseUrl;
  ngOnInit() {
    this.seoService.createLinkForCanonicalURL();
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/operation-maintanance/"
  },
  "headline": "Operation and Maintenance Services | Maganti IT",
  "description": "Information technology is key business enabler to support business growth for any sized company or for a government agency",
  "image": "https://mitresource.com/assets/images/application/application-bulidimage.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-28"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
   
    if (this.isBrowser) {
      AOS.init({ disable: 'mobile', duration: 2000, delay: 500, });
    }

    this.setTitleAndMetaTags();
  }
  ngAfterViewInit(): void {
    if (this.isBrowser) {
      const carouselSlider = new Swiper(this.swiperContainer.nativeElement, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        speed: 1000,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination-1',
          type: 'bullets',
          clickable: true
        },
        breakpoints: {
          1499: {
            slidesPerView: 1
          },
          1200: {
            slidesPerView: 1
          },
          991: {
            slidesPerView: 1
          },
          767: {
            slidesPerView: 1
          },
          575: {
            slidesPerView: 1
          }
        }
      });
    }
  }


  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Operation and Maintenance Services | Maganti IT');
    this.metaService.addTags([
      { name: 'description', content: 'Maganti IT offers affordable, reliable Operations and Maintenance Services to help monitor and protect your critical equipment and systems.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Operation and Maintenance Services | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/operation-maintanance/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/application/application-bulidimage.png' },
      { property: 'og:description', content: 'Maganti IT offers affordable, reliable Operations and Maintenance Services to help monitor and protect your critical equipment and systems.' },
    ]);
  }
}
